export const styles = {
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '14px 16px',
    transition: 'background-color 0.2s ease',
    borderRadius: '12px',
    '&:hover': {
      backgroundColor: 'rgb(242, 245, 255) !important',
    },
  },
  btn: {
    padding: 0,
  },
  label: { fontSize: '14px', fontFamily: 'Inter', lineHeight: '140%' },
  popover: {
    '& .MuiPopover-paper': {
      width: '200px',
      marginTop: '8px',
      background: '#FFFFFF',
      border: '1px solid #F3F4F9',
      boxShadow: '0px 4px 10px rgba(35, 37, 47, 0.1), 1px 2px 2px rgba(35, 37, 47, 0.04)',
      borderRadius: '12px',
      padding: '2px',
    },
  },
};
